/*
 * Registers the /field/-scoped service worker (public/field-sw.js).
 *
 * Sibling of registerSW.js (the root inert SW) — kept in its own module so
 * the root registration is provably untouched. Same production gate: skipped
 * under `npm start` so dev hot reload is never shadowed by a worker.
 *
 * Called lazily on field-zone entry (FieldZonePlaceholder useEffect), NOT at
 * app boot — the field worker should never install for users who never enter
 * the capture zone. register() is idempotent, but the module latch keeps
 * remounts from spamming it.
 */

let attempted = false;

export function registerFieldServiceWorker() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;
  if (attempted) return;
  attempted = true;

  // Scope '/field' (NO trailing slash): SW scope matching is a raw path
  // prefix, and the zone's entry URL is '/field' itself — a '/field/' scope
  // never controls it, so an offline reload of /field would bypass the
  // precache entirely (found live in 4.2c verification). '/field' covers
  // '/field' and '/field/*'; no other app route shares the prefix.
  navigator.serviceWorker
    .register('/field-sw.js', { scope: '/field' })
    .then(() => navigator.serviceWorker.getRegistrations())
    .then((regs) => {
      // Retire the legacy 4.1 '/field/'-scoped registration (exact match
      // only — never touches the root SW at scope '/').
      const legacy = regs.find((r) => new URL(r.scope).pathname === '/field/');
      if (legacy) return legacy.unregister();
      return undefined;
    })
    .catch((err) => {
      console.error('Field service worker registration failed:', err);
    });
}
